import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useMediaQueryContext } from "lib/mediaQueryContext";

import AddressInput from "components/checkout/form/addressInput/AddressInput";
import StoresMap from "../storesMap/StoresMap";

const Modal = dynamic(() => import("react-modal"));

export default function NearbyStoresForm({
    subject,
    isContainedInModal,
    onlyRedeemStores
}) {
    const { mobileView } = useMediaQueryContext();
    const [modalOpen, setModalState] = useState(false);
    const [addressData, setAddressData] = useState(false);

    const methods = useForm({
        mode: "onSubmit"
    });
    const { handleSubmit } = methods;

    const onSubmit = async data => {
        setModalState(true);
        setAddressData(data);
    };

    return (
        <>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <AddressInput
                        name="location"
                        label={`${subject}en in de buurt`}
                        options={{
                            placeholder: "Vul hier je woonplaats in",
                            required: false,
                            onBlur: handleSubmit(onSubmit),
                            onClick: () =>
                                mobileView ? setModalState(true) : {},
                            cityOnly: true,
                            instructions: "Selecteer een van de optie(s)"
                        }}
                    />
                </form>
            </FormProvider>
            {!isContainedInModal && (
                <Modal
                    isOpen={modalOpen}
                    contentLabel="locationModal"
                    onRequestClose={() => setModalState(false)}
                    ariaHideApp={false}
                    className="react-modal"
                    closeTimeoutMS={400}
                    overlayClassName="react-modal-overlay"
                >
                    <StoresMap
                        subject={subject}
                        initialAddressData={addressData}
                        onlyRedeemStores={onlyRedeemStores}
                        closeModal={() => setModalState(false)}
                    />
                </Modal>
            )}
        </>
    );
}

NearbyStoresForm.propTypes = {
    subject: PropTypes.string,
    data: PropTypes.shape({
        street: PropTypes.string,
        houseNumber: PropTypes.string,
        postalCode: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string
    }),
    isContainedInModal: PropTypes.bool,
    onlyRedeemStores: PropTypes.bool
};

NearbyStoresForm.defaultProps = {
    subject: undefined,
    data: undefined,
    isContainedInModal: false,
    onlyRedeemStores: false
};
